import { aggregateCrewProjects } from "@msuite/utils/plans";
import type { StaticCrew } from "@msuite/utils/types";
import { useMemo } from "react";
import { CommandPlanProject } from "./command-plan-project";
import { CommandPlanUserAssignment } from "./command-plan-user-assignment";

/** Props Interface */
interface CommandPlanCrewProps {
	crew: StaticCrew;
}

export function CommandPlanCrew({ crew }: CommandPlanCrewProps) {
	const aggregatedProjects = useMemo(() => {
		return aggregateCrewProjects(crew);
	}, [crew.projects]);

	/** Render */
	return (
		<div
			className="w-full grid gap-x-4 gap-y-4 break-inside-avoid-column p-2 odd:bg-primary-200 rounded-xl"
			style={{ gridTemplateColumns: "1fr 2fr" }}
		>
			<div className="col-span-2 card">
				<p className="heading">
					{crew.organizationName} {crew.ranking}
				</p>
			</div>
			<div className="v-stack">
				{crew.userAssignments.map((userAssignment) => (
					<CommandPlanUserAssignment
						userAssignment={userAssignment}
						key={userAssignment.userId}
					/>
				))}
			</div>
			<div className="v-stack">
				{aggregatedProjects.map((project) => (
					<CommandPlanProject
						key={project.id}
						project={project}
					/>
				))}
			</div>
		</div>
	);
}
